var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "CreateFaqs" } }, [
    _c("div", { staticClass: "header" }, [
      _c(
        "div",
        { staticClass: "title" },
        [
          _c(
            "IconButton",
            {
              attrs: {
                "on-click": function () {
                  return _vm.$emit("close")
                },
              },
            },
            [
              _c("i", { staticClass: "material-icons" }, [
                _vm._v("arrow_back_ios"),
              ]),
            ]
          ),
          _vm._v(
            "\n            " +
              _vm._s(_vm.$t("message.createFaq")) +
              "\n        "
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "description" }, [
        _vm._v(
          "\n            " +
            _vm._s(_vm.$t("message.createFaqDesc")) +
            "\n        "
        ),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "content" }, [
      _c("div", [_vm._v(_vm._s(_vm.$t("message.question")))]),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.question,
            expression: "question",
          },
        ],
        attrs: { type: "text" },
        domProps: { value: _vm.question },
        on: {
          input: function ($event) {
            if ($event.target.composing) {
              return
            }
            _vm.question = $event.target.value
          },
        },
      }),
      _vm._v(" "),
      _c("div", [_vm._v(_vm._s(_vm.$t("chatbotv2.answered")))]),
      _vm._v(" "),
      _c("textarea", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.answer,
            expression: "answer",
          },
        ],
        domProps: { value: _vm.answer },
        on: {
          input: function ($event) {
            if ($event.target.composing) {
              return
            }
            _vm.answer = $event.target.value
          },
        },
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "btn-container" },
        [
          _c(
            "SupsisButton",
            {
              staticClass: "sup-btn",
              attrs: { primary: "" },
              on: { click: _vm.saveFaq },
            },
            [
              _c("i", { staticClass: "material-icons" }, [_vm._v("save")]),
              _vm._v(" "),
              _c("span", [_vm._v(_vm._s(_vm.$t("message.save")))]),
            ]
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }